
import {GET_LANGUAGE_ALL} from "../constants/Language";

export const getLanguageAll = () => {
    return {
        type: GET_LANGUAGE_ALL.PENDING,
    };
};
